$(document).ready(function () {
  //$('.row.full-width.diff').html('');

  $("#RegisterViaQRCode_Recaptcha_Error").hide();
  $("#RVQC_SubmitButton").data("verified", false);

  const location = window.location.href;
  const locationSplit =
    location != null && location != "" ? location.split("/") : "";
  const finalRef =
    locationSplit != null && locationSplit != "" && Array.isArray(locationSplit)
      ? locationSplit[locationSplit.length - 1]
      : null;
  if (finalRef == "register" || finalRef == "Register") {
    $("#main-nav").hide();
    $(".nav--main").hide();
    $("footer").hide();
    $("#ot-sdk-btn").hide();
  }
  RVQC_InitializeMetroAreas_action();

  $("#RVQC_MetroAreaInput").on("change", function (e, arg) {
    event.preventDefault();
    let id = $("#RVQC_MetroAreaInput").find(":selected").val();
    let payload = { MetroAreaId: id };
    RVQC_LoadCommunities_action(payload);
  });

  $("#RVQC_CommunityInput").on("change", function (e, arg) {
    event.preventDefault();
    let id = $("#RVQC_CommunityInput").find(":selected").val();
    let payload = { CommunityId: id };
    RVQC_LoadSalesCounselors_action(payload);
  });

  $("#RVQC_HomebuyerCheckbox").on("click", function () {
    if ($(this).is(":checked")) $("#RVQC_HomebuyerForm").show("slow");
    else {
      $("#RVQC_HomebuyerForm").hide("fast");
      RVQC_ClearHomebuyerErrors_promise();
    }
  });

  $("#RVQC_AgentCheckbox").prop("checked", false);
  $("#RVQC_AgentForm").hide();

  $("#RVQC_AgentCheckbox").on("click", function () {
    const homebuyer = "homebuyer";
    const agent = "agent";
    if ($(this).is(":checked")) {
      $("#RVQC_AgentForm").show("slow");
      $("#registerViaQRCodeSubSource").val(agent);
    } else {
      $("#RVQC_AgentForm").hide("fast");
      $("#registerViaQRCodeSubSource").val(homebuyer);
      RVQC_ClearAgentErrors_promise();
    }
  });

  const nav = document.getElementById("MTH_Nav");
  const config = { attributes: true, childList: false, subtree: false };
  const mutationCallback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      const locationEvent = window.location.href;
      const locationSplitEvent =
        locationEvent != null && locationEvent != ""
          ? locationEvent.split("/")
          : "";
      const finalRefEvent =
        locationSplitEvent != null &&
        locationSplitEvent != "" &&
        Array.isArray(locationSplitEvent)
          ? locationSplitEvent[locationSplitEvent.length - 1]
          : null;
      if (
        mutation.type === "attributes" &&
        mutation.attributeName == "style" &&
        nav.style.display != "none" &&
        (finalRef == "register" || finalRef == "Register")
      ) {
        nav.style.display = "none";
      }
    }
  };
  const navObserver = new MutationObserver(mutationCallback);

  if (nav != null) navObserver.observe(nav, config);

  $("#RVQC_SubmitButton").on("click", function (e) {
    event.preventDefault();
    if (grecaptcha && grecaptcha.getResponse().length > 0) {
      if ($(this).prop("data-verified") == false) {
        RVQC_ShowRecaptchaError();
        if ($(this.form)[0].checkValidity() == false) {
          $(this.form).submit();
        } else {
          e.preventDefault();
        }
      } else {
        event.preventDefault();
        RVQC_HideRecaptchaError();

        const agentCheckBox = $("#RVQC_AgentCheckbox").is(":checked");
        const homeBuyerCheckBox = $("#RVQC_HomebuyerCheckbox").is(":checked");
        if (agentCheckBox && homeBuyerCheckBox) {
          RVQC_SubmitForm_Agent_With_Homebuyer_action();
        } else if (agentCheckBox) {
          RVQC_SubmitForm_Agent_action();
        } else if (homeBuyerCheckBox) {
          RVQC_SubmitForm_Homebuyer_action();
        } else {
        }
      }
    } else {
      showRecaptchaError();
    }
  });

  $("#RVQC_FirstName_Homebuyer").unbind("input");
  $("#RVQC_FirstName_Homebuyer").on("input", function (e) {
    var x = e.target.value.replace(/[0-9]/g, "").match(/(\D{1,49})/);
    if (x == null || !Array.isArray(x)) e.target.value = null;
    else e.target.value = x[0];
  });

  $("#RVQC_LastName_Homebuyer").unbind("input");
  $("#RVQC_LastName_Homebuyer").on("input", function (e) {
    var x = e.target.value.replace(/[0-9]/g, "").match(/(\D{1,49})/);
    if (x == null || !Array.isArray(x)) e.target.value = null;
    else e.target.value = x[0];
  });

  $("#RVQC_PhoneNumber_Homebuyer").unbind("input");
  $("#RVQC_PhoneNumber_Homebuyer").on("input", function (e) {
    var x = e.target.value
      .replace(/\D/g, "")
      .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    if (x == null || !Array.isArray(x)) e.target.value = null;
    else
      e.target.value = !x[2]
        ? x[1]
        : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
  });

  $("#RVQC_FirstName_Agent").unbind("input");
  $("#RVQC_FirstName_Agent").on("input", function (e) {
    var x = e.target.value.replace(/[0-9]/g, "").match(/(\D{1,49})/);
    if (x == null || !Array.isArray(x)) e.target.value = null;
    else e.target.value = x[0];
  });

  $("#RVQC_LastName_Agent").unbind("input");
  $("#RVQC_LastName_Agent").on("input", function (e) {
    var x = e.target.value.replace(/[0-9]/g, "").match(/(\D{1,49})/);
    if (x == null || !Array.isArray(x)) e.target.value = null;
    else e.target.value = x[0];
  });

  $("#RVQC_PhoneNumber_Agent").unbind("input");
  $("#RVQC_PhoneNumber_Agent").on("input", function (e) {
    var x = e.target.value
      .replace(/\D/g, "")
      .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    if (x == null || !Array.isArray(x)) e.target.value = null;
    else
      e.target.value = !x[2]
        ? x[1]
        : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
  });

  $("#RVQC_Zipcode_Agent").unbind("input");
  $("#RVQC_Zipcode_Agent").on("input", function (e) {
    var x = e.target.value.replace(/\D/g, "").match(/(\d{0,5})(\d{0,4})/);
    e.target.value = !x[2] ? x[1] : x[1] + "-" + x[2];
    if (x == null || !Array.isArray(x)) e.target.value = null;
    else e.target.value = x[0];
  });
});

//======================== Actions Start ============================//

const RVQC_InitializeMetroAreas_action = () => {
  return RVQC_MetroAreasSetLoading_promise()
    .then(RVQC_LoadMetroAreas_promise)
    .then(SetDropdownData_promise)
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      return RVQC_MetroAreasClearLoading_promise();
    });
};

const RVQC_LoadCommunities_action = (payload) => {
  return RVQC_CommunitiesSetLoading_promise(payload)
    .then(ClearSalesRepresentativeData_promise)
    .then(ClearCommunityData_promise)
    .then(RVQC_LoadCommunitiesForMetroArea_promise)
    .then(SetDropdownData_promise)
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      return RVQC_CommunitiesClearLoading_promise();
    });
};

const RVQC_LoadSalesCounselors_action = (payload) => {
  return RVQC_SalesCounselorSetLoading_promise(payload)
    .then(ClearSalesRepresentativeData_promise)
    .then(RVQC_LoadSalesCounselorsForCommunity_promise)
    .then(SetDropdownData_promise)
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      return RVQC_SalesCounselorClearLoading_promise();
    });
};

const RVQC_SubmitForm_Homebuyer_action = () => {
  return RVQC_GenerateBasicData_promise()
    .then(RVQC_ValidateBasicData_promise)
    .then(RVQC_GenerateHomebuyerData_promise)
    .then(RVQC_ValidateHomebuyerData_promise)
    .then(RVQC_SubmitRequest_promise)
    .then(RVQC_ShowThankYou_action)
    .catch((error) => {
      console.log(error);
      const { ShowError, Error, Response, Message } = error;

      if (ShowError) {
        RVQC_ShowError_action();
      }
    })
    .finally(() => {
      return RVQC_SalesCounselorClearLoading_promise();
    });
};

const RVQC_SubmitForm_Agent_action = () => {
  return RVQC_GenerateBasicData_promise()
    .then(RVQC_ValidateBasicData_promise)
    .then(RVQC_GenerateAgentData_promise)
    .then(RVQC_ValidateAgentData_promise)
    .then(RVQC_SubmitRequest_promise)
    .then(RVQC_ShowThankYou_action)
    .catch((error) => {
      console.log(error);
      const { ShowError, Error, Response, Message } = error;

      if (ShowError) {
        RVQC_ShowError_action();
      }
    })
    .finally(() => {
      return RVQC_SalesCounselorClearLoading_promise();
    });
};

const RVQC_SubmitForm_Agent_With_Homebuyer_action = () => {
  return RVQC_GenerateBasicData_promise()
    .then(RVQC_ValidateBasicData_promise)
    .then(RVQC_GenerateHomebuyerData_promise)
    .then(RVQC_ValidateHomebuyerData_promise)
    .then(RVQC_GenerateAgentData_promise)
    .then(RVQC_ValidateAgentData_promise)
    .then(RVQC_SubmitRequest_promise)
    .then(RVQC_ShowThankYou_action)
    .catch((error) => {
      const { ShowError, Error, Response, Message } = error;

      if (ShowError) {
        RVQC_ShowError_action();
      }

      console.log(Message);
    })
    .finally(() => {
      return RVQC_SalesCounselorClearLoading_promise();
    });
};

const RVQC_ShowError_action = () => {
  return RVQC_ClearThankYouMessage_promise()
    .then(RVQC_ClearForm_promise)
    .then(RVQC_SetErrorMessage_promise)
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {});
};

const RVQC_ShowThankYou_action = () => {
  return RVQC_ClearErrorMessage_promise()
    .then(RVQC_ClearForm_promise)
    .then(RVQC_SetThankYouMessage_promise)
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {});
};

const RVQC_ShowForm_action = () => {
  return RVQC_ClearThankYouMessage_promise()
    .then(RVQC_ClearErrorMessage_promise)
    .then(RVQC_SetForm_promise)
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {});
};

//======================== Actions End ==============================//

//======================== Promises Start ============================//

const RVQC_GenerateBasicData_promise = (payload = {}) => {
  return new Promise((resolve, reject) => {
    const metroAreaId = $("#RVQC_MetroAreaInput").find(":selected").val();
    const communityId = $("#RVQC_CommunityInput").find(":selected").val();
    const salesCounselor = $("#RVQC_SalesCounselor").find(":selected").val();
    const agentCheckBox = $("#RVQC_AgentCheckbox").is(":checked");
    const homeBuyerCheckBox = $("#RVQC_HomebuyerCheckbox").is(":checked");
    const gaClientID = $("#registerViaQRCodeGAClientId").val();
    const pagePath = $("#registerViaQRCodePagePath").val();
    const origin = $("#registerViaQRCodeOrigin").val();
    const contactType = $("#registerViaQRCodeType").val();
    const leadSource = $("#registerViaQRLeadSource").val();
    const subSource = $("#registerViaQRCodeSubSource").val();
    const gRecaptchaResponse = $("#gRecaptchaResponse").val();

    resolve({
      metroArea: metroAreaId,
      community: communityId,
      salesCounselor: salesCounselor,
      gaClientId: gaClientID,
      pagePath: pagePath,
      origin: origin,
      contactType: contactType,
      leadSource: leadSource,
      subSource: subSource,
      agent_checkbox: agentCheckBox,
      home_buyer_checkbox: homeBuyerCheckBox,
      gRecaptchaResponse: gRecaptchaResponse,
    });
  });
};

const RVQC_ValidateBasicData_promise = (payload = {}) => {
  return new Promise((resolve, reject) => {
    const {
      metroArea,
      community,
      salesCounselor,
      gaClientId,
      pagePath,
      origin,
      contactType,
      leadSource,
      subSource,
      agent_checkbox,
      home_buyer_checkbox,
    } = payload;

    if (metroArea == null || metroArea == "" || metroArea == "-1") {
      $("#RVQC_MetroAreaInput_Error").show("slow");
      reject({
        error: {
          ShowError: true,
          Message: "There was no metro selected",
        },
      });
    } else $("#RVQC_MetroAreaInput_Error").hide("fast");

    //if (community == null || community == "" || community == "-1")
    //    $("#RVQC_CommunityInput_Error").show("slow");
    //else
    //    $("#RVQC_CommunityInput_Error").hide("fast");

    //if (salesCounselor == null || salesCounselor == "" || salesCounselor == "-1")
    //    $("#RVQC_SalesCounselor_Error").show("slow");
    //else
    //    $("#RVQC_SalesCounselor_Error").hide("fast");

    if (!agent_checkbox && !home_buyer_checkbox) {
      console.log("No checkbox was selected for attendees");
    }

    if (gaClientId == null || gaClientId == "")
      console.log("GA Client Id data was missing");
    if (pagePath == null || pagePath == "")
      console.log("Page path data was missing");
    if (origin == null || origin == "") console.log("Origin data was missing");
    if (contactType == null || contactType == "")
      console.log("Contact Type data was missing");
    if (leadSource == null || leadSource == "")
      console.log("Lead Source data was missing");
    if (subSource == null || subSource == "")
      console.log("Sub Source data was missing");

    resolve(payload);
  });
};

const RVQC_GenerateHomebuyerData_promise = (payload = {}) => {
  return new Promise((resolve, reject) => {
    const { home_buyer_checkbox } = payload;

        if (!home_buyer_checkbox)
            reject({ Message: "Homebuyer tour was not selected, but homebuyer tour data generated" });
        else {
            const firstName = $("#RVQC_FirstName_Homebuyer").val();
            const lastName = $("#RVQC_LastName_Homebuyer").val();
            const email = $("#RVQC_EmailAddress_Homebuyer").val();
            const phone = $("#RVQC_PhoneNumber_Homebuyer").val();
            const homebuyerSMSMarketingOpt = $('#homebuyerSMSMarketingOpt').is(':checked');
        

            const homebuyerdata = {
                firstName: firstName,
                lastName: lastName,
                email: email,
                phone: phone,
                homebuyerSMSMarketingOpt: homebuyerSMSMarketingOpt
            }

      payload["homebuyer"] = homebuyerdata;
      resolve(payload);
    }
  });
};

const RVQC_ValidateHomebuyerData_promise = (payload = {}) => {
  return new Promise((resolve, reject) => {
    const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    const emailRegex =
      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.+[a-zA-Z0-9.]/;
    const firstNameRegex = /^[A-z\s]{1,100}/;
    const lastNameRegex = /^[A-z\s]{1,100}/;
    const { homebuyer } = payload;

    if (homebuyer == null) reject({ Message: "Homebuyer data was missing" });
    else {
      const { firstName, lastName, email, phone } = homebuyer;

      let valid = true;
      let errorMessage = "";

      if (
        firstName == null ||
        firstName == "" ||
        !firstNameRegex.test(firstName)
      ) {
        valid = false;
        errorMessage = errorMessage.concat("Error validating First Name.\n");
        $("#RVQC_FirstName_Homebuyer_Error").show("slow");
      } else $("#RVQC_FirstName_Homebuyer_Error").hide("fast");

      if (lastName == null || lastName == "" || !lastNameRegex.test(lastName)) {
        valid = false;
        errorMessage = errorMessage.concat("Error validating Last Name.\n");
        $("#RVQC_LastName_Homebuyer_Error").show("slow");
      } else $("#RVQC_LastName_Homebuyer_Error").hide("fast");

      if (phone == null || phone == "" || !phoneRegex.test(phone)) {
        valid = false;
        errorMessage = errorMessage.concat(
          "Error validating Homebuyer Phone.\n"
        );
        $("#RVQC_PhoneNumber_Homebuyer_Error").show("slow");
      } else $("#RVQC_PhoneNumber_Homebuyer_Error").hide("fast");

      if (email == null || email == "" || !emailRegex.test(email)) {
        valid = false;
        errorMessage = errorMessage.concat(
          "Error validating Homebuyer Email.\n"
        );
        $("#RVQC_EmailAddress_Homebuyer_Error").show("slow");
      } else $("#RVQC_EmailAddress_Homebuyer_Error").hide("fast");

      if (valid) {
        resolve(payload);
      } else {
        reject({ Message: errorMessage });
      }
    }
  });
};

const RVQC_GenerateAgentData_promise = (payload = {}) => {
  return new Promise((resolve, reject) => {
    const { agent_checkbox } = payload;

        if (!agent_checkbox)
            reject({ Message: "Agent tour was not selected, but agent tour data generated" });
        else {
            const firstName = $("#RVQC_FirstName_Agent").val();
            const lastName = $("#RVQC_LastName_Agent").val();
            const email = $("#RVQC_EmailAddress_Agent").val();
            const phone = $("#RVQC_PhoneNumber_Agent").val();
            const agency = $("#RVQC_Agency_Agent").val();
            const zipcode = $("#RVQC_Zipcode_Agent").val();
            const agentSMSMarketingOpt = $('#agentSMSMarketingOpt').is(':checked');
            const agentData = {
                firstName: firstName,
                lastName: lastName,
                email: email,
                phone: phone,
                agency: agency,
                zipCode: zipcode,
                agentSMSMarketingOpt: agentSMSMarketingOpt
            }

      payload["agent"] = agentData;
      resolve(payload);
    }
  });
};

const RVQC_ValidateAgentData_promise = (payload = {}) => {
  return new Promise((resolve, reject) => {
    const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    const emailRegex =
      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.+[a-zA-Z0-9.]/;
    const firstNameRegex = /^[A-z\s]{1,100}/;
    const lastNameRegex = /^[A-z\s]{1,100}/;
    const { agent } = payload;

    if (agent == null) reject({ Message: "Agent data was missing" });
    else {
      const { firstName, lastName, email, phone, agency, zipCode } = agent;

      let valid = true;
      let errorMessage = "";

      if (
        firstName == null ||
        firstName == "" ||
        !firstNameRegex.test(firstName)
      ) {
        valid = false;
        errorMessage = errorMessage.concat("Error validating First Name.\n");
        $("#RVQC_FirstName_Agent_Error").show("slow");
      } else $("#RVQC_FirstName_Agent_Error").hide("fast");

      if (lastName == null || lastName == "" || !lastNameRegex.test(lastName)) {
        valid = false;
        errorMessage = errorMessage.concat("Error validating Last Name.\n");
        $("#RVQC_LastName_Agent_Error").show("slow");
      } else $("#RVQC_LastName_Agent_Error").hide("fast");

      if (phone == null || phone == "" || !phoneRegex.test(phone)) {
        valid = false;
        errorMessage = errorMessage.concat("Error validating Agent Phone.\n");
        $("#RVQC_PhoneNumber_Agent_Error").show("slow");
      } else $("#RVQC_PhoneNumber_Agent_Error").hide("fast");

      if (email == null || email == "" || !emailRegex.test(email)) {
        valid = false;
        errorMessage = errorMessage.concat("Error validating Agent Email.\n");
        $("#RVQC_EmailAddress_Agent_Error").show("slow");
      } else $("#RVQC_EmailAddress_Agent_Error").hide("fast");

      if (agency == null || agency == "") {
        valid = false;
        errorMessage = errorMessage.concat("Error validating Agent Agency.\n");
        $("#RVQC_Agency_Agent_Error").show("slow");
      } else $("#RVQC_Agency_Agent_Error").hide("fast");

      if (zipCode == null || zipCode == "") {
        valid = false;
        errorMessage = errorMessage.concat("Error validating Agent Email.\n");
        $("#RVQC_Zipcode_Agent_Error").show("slow");
      } else $("#RVQC_Zipcode_Agent_Error").hide("fast");

      if (valid) {
        resolve(payload);
      } else {
        reject({ Message: errorMessage });
      }
    }
  });
};

const RVQC_SubmitRequest_promise = (payload = {}) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      method: "POST",
      url: "/api/sitecore/RegisterViaQRCode/Index",
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify(payload),
      success: function (data) {
        payload["Response"] = data;
        const { Success } = data;

        if (Success == true) {
          resolve(payload);
        } else {
          reject({
            ShowError: true,
            Message: "There was an error submitting the register form",
          });
        }
      },
      error: function (error) {
        reject({
          ShowError: true,
          Error: error,
          Message: "There was an error submitting the register form",
        });
      },
    });
  });
};

const RVQC_MetroAreasSetLoading_promise = (payload) => {
  return new Promise((resolve, reject) => {
    $("#RVQC_MetroAreaInputWrapper").hide("fast");
    $("#RVQC_MetroAreaLoading").show("slow");
    resolve(payload);
  });
};

const RVQC_MetroAreasClearLoading_promise = (payload) => {
  return new Promise((resolve, reject) => {
    $("#RVQC_MetroAreaLoading").hide("fast");
    $("#RVQC_MetroAreaInputWrapper").show("slow");
    resolve(payload);
  });
};

const RVQC_CommunitiesSetLoading_promise = (payload) => {
  return new Promise((resolve, reject) => {
    $("#RVQC_CommunityInputWrapper").hide("fast");
    $("#RVQC_CommunityLoading").show("slow");
    resolve(payload);
  });
};

const RVQC_CommunitiesClearLoading_promise = (payload) => {
  return new Promise((resolve, reject) => {
    $("#RVQC_CommunityLoading").hide("fast");
    $("#RVQC_CommunityInputWrapper").show("slow");
    resolve(payload);
  });
};

const RVQC_SalesCounselorSetLoading_promise = (payload) => {
  return new Promise((resolve, reject) => {
    $("#RVQC_SalesCounselorInputWrapper").hide("fast");
    $("#RVQC_SalesCounselorLoading").show("slow");
    resolve(payload);
  });
};

const RVQC_SalesCounselorClearLoading_promise = (payload) => {
  return new Promise((resolve, reject) => {
    $("#RVQC_SalesCounselorLoading").hide("fast");
    $("#RVQC_SalesCounselorInputWrapper").show("slow");
    resolve(payload);
  });
};

const RVQC_LoadMetroAreas_promise = (payload = {}) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: "/api/Sitecore/RegisterViaQRCode/Metro",
      method: "GET",
      success: function (data) {
        payload["Data"] = data.areas;
        payload["Id"] = null;
        payload["Target"] = $("#RVQC_MetroAreaInput");
        payload["Type"] = "MetroArea";
        resolve(payload);
      },
      error: function (error) {
        reject({
          Message:
            "CarouselRetrieveTimesDataByDate_promise: There was a problem retrieving information from the salesforce service\n",
        });
      },
    });
  });
};

const ClearCommunityData_promise = (payload) => {
  return new Promise((resolve, reject) => {
    $("#RVQC_CommunityInput").empty();
    resolve(payload);
  });
};

const ClearSalesRepresentativeData_promise = (payload) => {
  return new Promise((resolve, reject) => {
    $("#RVQC_SalesCounselor").empty();
    resolve(payload);
  });
};

const RVQC_LoadCommunitiesForMetroArea_promise = (payload) => {
  const { MetroAreaId } = payload;

  return new Promise((resolve, reject) => {
    $.ajax({
      url:
        "/api/Sitecore/RegisterViaQRCode/Community?MetroAreaId=" + MetroAreaId,
      method: "GET",
      success: function (data) {
        payload["Data"] = data.areas;
        payload["Id"] = null;
        payload["Target"] = $("#RVQC_CommunityInput");
        payload["Type"] = "Community";
        resolve(payload);
      },
      error: function (error) {
        reject({
          Message:
            "CarouselRetrieveTimesDataByDate_promise: There was a problem retrieving information from the salesforce service\n",
        });
      },
    });
  });
};

const RVQC_LoadSalesCounselorsForCommunity_promise = (payload) => {
  const { CommunityId } = payload;

  return new Promise((resolve, reject) => {
    $.ajax({
      url:
        "/api/Sitecore/RegisterViaQRCode/SalesRepresentatives?CommunityId=" +
        CommunityId,
      method: "GET",
      success: function (data) {
        payload["Data"] = data;
        payload["Id"] = null;
        payload["Target"] = $("#RVQC_SalesCounselor");
        payload["Type"] = "SalesRepresentatives";
        resolve(payload);
      },
      error: function (error) {
        reject({
          Message:
            "CarouselRetrieveTimesDataByDate_promise: There was a problem retrieving information from the salesforce service\n",
        });
      },
    });
  });
};

const RVQC_Submit_promise = (payload) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      method: "POST",
      url: "/api/sitecore/RegisterViaQRCode/Index",
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify(payload),
      success: function (data) {
        var responseJson = data;
        payload.Data = responseJson;
        resolve(payload);
      },
      error: function (error) {
        reject({
          Message:
            "CarouselRetrieveTimesDataByDate_promise: There was a problem retrieving information from the salesforce service\n",
        });
      },
    });
  });
};

const RVQC_ClearBasicErrors_promise = (payload) => {
  return new Promise((resolve, reject) => {
    $("#RVQC_MetroAreaInput_Error").hide("fast");
    $("#RVQC_CommunityInput_Error").hide("fast");
    $("#RVQC_SalesCounselor_Error").hide("fast");

    resolve(payload);
  });
};

const RVQC_ClearHomebuyerErrors_promise = (payload) => {
  return new Promise((resolve, reject) => {
    $("#RVQC_FirstName_Homebuyer_Error").hide("fast");
    $("#RVQC_LastName_Homebuyer_Error").hide("fast");
    $("#RVQC_PhoneNumber_Homebuyer_Error").hide("fast");
    $("#RVQC_EmailAddress_Homebuyer_Error").hide("fast");

    resolve(payload);
  });
};
const RVQC_ClearAgentErrors_promise = (payload) => {
  return new Promise((resolve, reject) => {
    $("#RVQC_FirstName_Agent_Error").hide("fast");
    $("#RVQC_LastName_Agent_Error").hide("fast");
    $("#RVQC_PhoneNumber_Agent_Error").hide("fast");
    $("#RVQC_EmailAddress_Agent_Error").hide("fast");
    $("#RVQC_Agency_Agent_Error").hide("fast");
    $("#RVQC_Zipcode_Agent_Error").hide("fast");
    resolve(payload);
  });
};

const RVQC_SetThankYouMessage_promise = (payload) => {
  return new Promise((resolve, reject) => {
    $("#RegisterViaQRCodeThankYou").show("slow");
    resolve(payload);
  });
};

const RVQC_ClearThankYouMessage_promise = (payload) => {
  return new Promise((resolve, reject) => {
    $("#RegisterViaQRCodeThankYou").hide("fast");
    resolve(payload);
  });
};

const RVQC_SetErrorMessage_promise = (payload) => {
  return new Promise((resolve, reject) => {
    $("#RegisterViaQRCodeError").show("slow");
    resolve(payload);
  });
};

const RVQC_ClearErrorMessage_promise = (payload) => {
  return new Promise((resolve, reject) => {
    $("#RegisterViaQRCodeError").hide("fast");
    resolve(payload);
  });
};

const RVQC_SetForm_promise = (payload) => {
  return new Promise((resolve, reject) => {
    $("#RegisterViaQRCodeForm").show("slow");
    resolve(payload);
  });
};

const RVQC_ClearForm_promise = (payload) => {
  return new Promise((resolve, reject) => {
    $("#RegisterViaQRCodeForm").hide("fast");
    resolve(payload);
  });
};
//======================== Promises End ==============================//

const SetDropdownData_promise = (payload) => {
  return new Promise((resolve, reject) => {
    const { Data, Target, Id, Type } = payload;

    Target.prop("disabled", false);

    if (Type == "SalesRepresentatives") {
      $.each(Data, function (i, entry) {
        if (entry == null || entry.Deleted == "True") return;

        if (entry.RepresentativeName == "Sales Counselor" && entry.id == "-1") {
          Target.append(
            '<option value="' +
              entry.RepresentativeId +
              '" selected>' +
              entry.RepresentativeName +
              "</option>"
          );
        } else if (entry.id == "-1") {
          Target.append(
            '<option value="' +
              entry.RepresentativeId +
              '"  hidden>' +
              entry.RepresentativeName +
              "</option>"
          );
        } else if (entry.id == Id) {
          Target.append(
            '<option value="' +
              entry.RepresentativeId +
              '" >' +
              entry.RepresentativeName +
              "</option>"
          );
        } else {
          Target.append(
            '<option value="' +
              entry.RepresentativeId +
              '">' +
              entry.RepresentativeName +
              "</option>"
          );
        }
      });
    } else {
      $.each(Data, function (i, entry) {
        if (entry == null) return;
        if (entry.id == "-1") {
          Target.append(
            '<option value="' +
              entry.id +
              '"  selected>' +
              entry.displayName +
              "</option>"
          );
        } else {
          Target.append(
            '<option value="' +
              entry.id +
              '">' +
              entry.displayName +
              "</option>"
          );
        }
      });
    }

    resolve(payload);
  });
};

function appendInputs(data, location, id) {
  $.each(_.sortBy(data.areas), function (i, area) {
    if (!area.id || !area.displayName) return;
    if (area.id == id) {
      location.append(
        '<option value="' +
          area.id +
          '" selected="selected">' +
          area.displayName +
          "</option>"
      );
    } else {
      location.append(
        '<option value="' + area.id + '">' + area.displayName + "</option>"
      );
    }
  });
}

var VerifyViaQRCodeCallback = function (response) {
  $("#gRecaptchaResponse").prop("value", response);
  $("#RVQC_SubmitButton").data("verified", true);
  $("#RVQC_SubmitButton").prop("disabled", false);
  RVQC_HideRecaptchaError();
};

var CallbackViaQRCodeCallbackTimeout = function () {
  $("#RVQC_SubmitButton").data("verified", false);
  $("#RVQC_SubmitButton").prop("disabled", true);
  RVQC_ShowRecaptchaError();
};

function RVQC_ShowRecaptchaError() {
  $("#RegisterViaQRCode_Recaptcha_Error").show();
  $(".g-recaptcha iframe").addClass("recaptcha-invalid");
}

function RVQC_HideRecaptchaError() {
  $("#RegisterViaQRCode_Recaptcha_Error").hide();
  $(".g-recaptcha iframe").removeClass("recaptcha-invalid");
}
